import React, { useState, useEffect } from 'react'
import { Space, Col, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { backendGetRequest } from '../../../../helpers/callBackend'
import HideOnMobile from '../../../../components/generic/hideOnMobile'
import AddRecipientButton from '../../../../components/specific/payments/recipient/newRecipient'
import AddRecipientsCsvButton from '../../../../components/specific/payments/recipient/addRecipientsCsvButton'
import RecipientsTable from '../../../../components/specific/payments/recipientsTable'
import HeaderBox from '../../../../components/generic/arpariBoxes/headerBox'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import theme from '../../../../helpers/theme'
import OuterBox from '../../../../components/generic/arpariBoxes/OuterBox'

const ManageRecipients = () => {
  const [loadingRecipients, setLoadingRecipients] = useState(true)
  const [recipients, setRecipients] = useState([])
  const [showRecipients, setShowRecipients] = useState([])

  const addNewRecipientToExternal = (newRecipient) => {
    const newRecipientObject = {
      id: newRecipient.id,
      name: newRecipient.retrieved_values.name,
      nickname: newRecipient.retrieved_values.nickname,
    }

    setRecipients((prevState) => {
      return [...prevState, newRecipientObject]
    })
  }

  const deleteRecipientInExternal = (selectedRecipientId) => {
    setRecipients((prevState) => {
      let updatedRecipients = prevState.filter((recipient) => recipient.id !== selectedRecipientId)
      return updatedRecipients
    })
  }

  useEffect(() => {
    setRecipients([])
    setShowRecipients([])
    backendGetRequest('/api/payments/counterparty/', { params: { pageIndex: 0 } }, '').then((res) => {
      for (let page = 1; page <= res?.data?.total_pages; page++) {
        backendGetRequest('/api/payments/counterparty/', { params: { pageIndex: page } }, '').then((res) => {
          setRecipients((prevRecipients) =>
            [...prevRecipients, ...res?.data?.data].sort((a, b) => {
              const nameA = a?.retrieved_values?.name || ''
              const nameB = b?.retrieved_values?.name || ''
              return nameA.toLowerCase().localeCompare(nameB.toLowerCase())
            })
          )
          setShowRecipients((prevShowRecipients) =>
            [...prevShowRecipients, ...res.data.data].sort((a, b) => {
              const nameA = a?.retrieved_values?.name || ''
              const nameB = b?.retrieved_values?.name || ''
              return nameA.toLowerCase().localeCompare(nameB.toLowerCase())
            })
          )
          setLoadingRecipients(false)
        })
      }
    })
  }, [])

  const handleSearch = (e) => {
    if (e.target.value === '') {
      setShowRecipients([...recipients])
    } else {
      const search_text = e.target.value
      const data = [...recipients]
      const resData = []
      for (let i = 0; i < data.length; i++) {
        const recipientName = data[i].retrieved_values?.name || ''
        const recipientNickname = data[i].retrieved_values?.nickname || ''
        if (
          recipientName.toLowerCase().startsWith(search_text.toLowerCase()) ||
          recipientNickname.toLowerCase().startsWith(search_text.toLowerCase())
        ) {
          resData.push(data[i])
        }
      }
      const sortedData = resData.sort((a, b) => {
        const nameA = a.retrieved_values?.name.toLowerCase() || ''
        const nameB = b.retrieved_values?.name.toLowerCase() || ''
        return nameA.localeCompare(nameB)
      })
      setShowRecipients(sortedData)
    }
  }

  return (
    <OuterBox>
      <Box sx={{ margin: theme.dashboard.margins }}>
        <Stack spacing={1}>
          <HeaderBox
            title='Recipients'
            actions={
              <HideOnMobile>
                <Space>
                  <AddRecipientButton
                    onSuccessFunc={addNewRecipientToExternal}
                    setRecipients={setRecipients}
                    setShowRecipients={setShowRecipients}
                    showRecipients={showRecipients}
                  />
                  <AddRecipientsCsvButton />
                </Space>
              </HideOnMobile>
            }
          />

          <Space direction='vertical' style={{ width: '100%' }}>
            <Col span={16}>
              <Input
                disabled={loadingRecipients}
                placeholder='Search'
                prefix={<SearchOutlined />}
                onChange={handleSearch}
              />
            </Col>
            <RecipientsTable
              onSuccessFuncDelete={deleteRecipientInExternal}
              onSuccessFuncEdit={addNewRecipientToExternal}
              setRecipients={setRecipients}
              setShowRecipients={setShowRecipients}
              recipientsData={showRecipients}
              loading={loadingRecipients}
            />
          </Space>
        </Stack>
      </Box>
    </OuterBox>
  )
}

export default ManageRecipients
